import type { QueryResult } from 'react-apollo';

import { keys as sessionStorageKeys } from '@confluence/storage-manager';

import type { FeedContentQuery, FeedContentQueryVariables } from './__types__/FeedContentQuery';
import { FollowingFeedSortByValue } from './Feed';
import { useFeedDropdownStorage } from './useFeedDropdownStorage';

export const useFeedSortingStorage = (
	feedContentQuery: QueryResult<FeedContentQuery, FeedContentQueryVariables>,
): {
	feedSorting: FollowingFeedSortByValue;
	setFeedSorting: (sorting: FollowingFeedSortByValue) => void;
} => {
	const { value: feedSorting, setValue: setFeedSorting } = useFeedDropdownStorage<
		FeedContentQuery,
		FeedContentQueryVariables,
		FollowingFeedSortByValue
	>(feedContentQuery, {
		defaultValue: FollowingFeedSortByValue.Relevant,
		sessionStorageKey: sessionStorageKeys.HOME_FOLLOWING_FEED_SORTING,
	});

	return { feedSorting, setFeedSorting };
};
